import { useMemo, useState } from 'react';
import { hotMovies } from '@/mocks/movies';
import SectionHeading from './SectionHeading';

const filters = ['全部', '动作', '科幻', '喜剧', '悬疑', '剧情', '动画', '爱情', '冒险'];

export default function HotMovies() {
  const [active, setActive] = useState('全部');
  const [keyword, setKeyword] = useState('');

  const list = useMemo(() => {
    const kw = keyword.trim().toLowerCase();
    return hotMovies.filter((m) => {
      const matchGenre = active === '全部' || m.genres.includes(active);
      const matchKw =
        !kw ||
        m.title.toLowerCase().includes(kw) ||
        m.subtitle.toLowerCase().includes(kw) ||
        m.genres.some((g) => g.toLowerCase().includes(kw)) ||
        m.region.toLowerCase().includes(kw);
      return matchGenre && matchKw;
    });
  }, [active, keyword]);

  return (
    <section id="hot" className="w-full bg-background-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <SectionHeading
            eyebrow="热门影片 · 实时热度"
            title="当下最受关注的电影"
            desc="按热度指数与评分综合排序。切换题材标签或输入片名、地区关键词，列表会即时过滤出你想看的内容。"
          />
          <div className="relative w-full lg:w-72 shrink-0">
            <i className="ri-search-line absolute left-3 top-1/2 -translate-y-1/2 text-foreground-400 text-base"></i>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索片名、类型或地区"
              className="w-full pl-10 pr-4 py-2.5 rounded-md bg-background-100 border border-background-200 text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 focus:bg-background-50 transition-colors"
            />
          </div>
        </div>

        <div className="mt-8 flex flex-wrap gap-2">
          {filters.map((f) => (
            <button
              key={f}
              type="button"
              onClick={() => setActive(f)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition-colors whitespace-nowrap ${
                active === f
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-100 text-foreground-700 hover:bg-secondary-100 hover:text-secondary-900'
              }`}
            >
              {f}
            </button>
          ))}
        </div>

        {list.length > 0 ? (
          <div className="mt-8 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6 gap-4 md:gap-5">
            {list.map((m) => (
              <article key={m.id} className="group cursor-pointer">
                <div className="relative rounded-lg overflow-hidden aspect-[2/3] bg-background-200">
                  <img
                    src={m.poster}
                    alt={`${m.title} 电影海报，${m.genres.join('、')}`}
                    className="w-full h-full object-cover object-top transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity"></div>
                  <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-accent-500 text-accent-950 text-[11px] font-medium">
                    {m.quality}
                  </span>
                  <span className="absolute top-2 right-2 inline-flex items-center gap-1 px-2 py-0.5 rounded-md bg-foreground-950/70 text-accent-300 text-[11px]">
                    <i className="ri-star-fill"></i>
                    {m.rating}
                  </span>
                  <span className="absolute bottom-2 left-2 right-2 text-[11px] text-background-50 opacity-0 group-hover:opacity-100 transition-opacity inline-flex items-center gap-1">
                    <i className="ri-fire-fill text-accent-400"></i>
                    热度 {(m.hot / 10000).toFixed(1)}万
                  </span>
                </div>
                <h3 className="mt-3 font-heading font-bold text-sm md:text-base text-foreground-950 truncate">
                  {m.title}
                </h3>
                <p className="mt-1 text-xs text-foreground-500 truncate">
                  {m.year} · {m.region} · {m.genres.join(' / ')}
                </p>
                <p className="mt-0.5 text-xs text-foreground-400">{m.duration}</p>
              </article>
            ))}
          </div>
        ) : (
          <div className="mt-12 py-16 text-center rounded-lg bg-background-100 border border-background-200/70">
            <i className="ri-search-eye-line text-4xl text-foreground-300"></i>
            <p className="mt-4 text-foreground-600">没有找到匹配的影片</p>
            <p className="mt-1 text-sm text-foreground-400">试试更换题材标签，或缩短关键词后重新搜索</p>
            <button
              type="button"
              onClick={() => {
                setActive('全部');
                setKeyword('');
              }}
              className="mt-5 px-5 py-2 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors"
            >
              重置筛选条件
            </button>
          </div>
        )}
      </div>
    </section>
  );
}